import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/shared/lib/utils"
import { Slot } from "radix-ui"

// As três variantes são o único vocabulário de estado que este componente
// conhece: um fundo lavado (`selo-*`) com a cor de texto do estado
// correspondente (`aviso`, `sucesso`, `perigo`). É cada chamador de `Badge`
// que decide, com o vocabulário do próprio domínio, qual das três se aplica —
// o mapeamento por módulo fica registrado em `docs/identidade-visual.md`.
const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center whitespace-nowrap rounded-pill px-2.5 py-[3px] font-mono text-[10.5px] tracking-[0.03em]",
  {
    variants: {
      variant: {
        pendente: "bg-selo-pendente text-aviso",
        concluido: "bg-selo-concluido text-sucesso",
        vencido: "bg-selo-vencido text-perigo",
      },
    },
    defaultVariants: {
      variant: "pendente",
    },
  }
)

function Badge({
  className,
  variant = "pendente",
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : "span"

  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
